<template>
  <ul class="aoformdroplist" role="listbox">
    <li role="option" 
        v-for="(option, index) in options" 
        :key="option + '-' + index"
        @click="optionSelect(option, index)"
        @keydown.enter.space="optionSelect(option, index)"
        :tabindex="$store.state.loading?-1:0"
        v-html="searchedOptions[index]"
      ></li>
  </ul>
</template>

<script>
export default {
  props: {
    options: {type: Array, required: true},
    search: {type: String, default: ''}
  },
  methods:{
    optionSelect(option, index){
      this.$emit('input', option, index)
      document.activeElement.blur()
    }
  },
  computed:{
    searchedOptions(){
      if (!this.search)
        return this.options
      return this.options.map(option=>{
        let s = this.search
        let searchRegExp = new RegExp(s,'gi')
        while(option . match(searchRegExp) == null && s.length > 1) {
          s = s.substring(0, s.length - 1)
          searchRegExp = new RegExp(s, 'gi') 
        }
        if (s.length)
          option = option.replace(searchRegExp, `<span class="aoformdroplist__red">${s}</span>`)
        return option 
      })
    }
  }
}
</script>

<style lang="sass">
$background: white
$font: black
$red: #E9041E
$notred: white
$gray: #807D7D
$light: #BFBEBE
$lightgray: #F2F2F2  
.aoformdroplist
  display: block
  pointer-events: none
  opacity: 0
  width: 100%
  position: absolute
  z-index: 2
  top: calc(100% + 2px)
  left: 0
  background: $background
  padding: 0
  margin: 0
  box-shadow: 0 2px 5px rgba(0,0,0,.2)
  li
    display: block
    outline: none
    cursor: pointer
    color: $gray
    font-size: 18px
    line-height: 26px
    padding: 10px 18px
    &:hover, &:focus
      background: $lightgray
  &__red
    color: $red

</style>